import { render, staticRenderFns } from "./CreateFee.vue?vue&type=template&id=65ea4d7c&scoped=true"
import script from "./CreateFee.vue?vue&type=script&lang=ts"
export * from "./CreateFee.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ea4d7c",
  null
  
)

export default component.exports